export enum agFilterNames {
  text = 'agTextColumnFilter',
  date = 'agDateColumnFilter',
  number = 'agNumberColumnFilter',
  set = 'agSetColumnFilter'
}